/**
 * @fileoverview ข้อความ + ปุ่มลองใหม่เมื่อโหลด Google Maps ไม่สำเร็จ (ใช้ร่วมทุก loader)
 * @module components/maps/MapsLoadError
 */
import React from 'react';
import { t } from '../CustomComponent';

export default function MapsLoadError({ containerStyle, onRetry }) {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center bg-light text-center p-4 h-100"
      style={containerStyle}
    >
      <div className="text-danger mb-3">{t('map_load_failed')}</div>
      <button type="button" className="btn btn-primary" onClick={onRetry}>
        {t('map_retry')}
      </button>
    </div>
  );
}
